module.exports={
	"Form": "TestSpecificationSetViewManifest",
	"Scope": "TestSpecificationSet-View",
	"Descriptors":
	{
		"TestSpecificationSetDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationSet-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationSet-View-Identity",
				"Group": "TestSpecificationSet-View-Identity"
			}
		},
		"TestSpecificationSetDetails.Year":
		{
			"Name": "Year",
			"Hash": "TestSpecificationSet-View-Year",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationSet-View-Details",
				"Group": "TestSpecificationSet-View-Details"
			}
		},
		"TestSpecificationSetDetails.IDTestSpecificationSet":
		{
			"Name": "IDTest Specification Set",
			"Hash": "TestSpecificationSet-View-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.GUIDTestSpecificationSet":
		{
			"Name": "GUIDTest Specification Set",
			"Hash": "TestSpecificationSet-View-GUIDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecificationSet-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecificationSet-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecificationSet-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		},
		"TestSpecificationSetDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecificationSet-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-View-DataAudit",
				"Group": "TestSpecificationSet-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationSet-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationSet-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationSet-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationSet-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecificationSet-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecificationSet-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
